'use client';

import { useEffect, useState } from 'react';

/**
 * Returns true after the component has mounted on the client.
 * Used to avoid rendering client-only content during SSR (e.g. to prevent
 * hydration mismatches when reading from window/sessionStorage).
 *
 * We use useState + useEffect (not useSyncExternalStore) for simplicity and
 * accept one extra render. The set-state-in-effect rule is suppressed here
 * because this is the intended pattern for "has mounted on client" with no
 * external store to subscribe to.
 */
export function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional "has mounted on client" check; no external store to subscribe to
    setIsClient(true);
  }, []);

  return isClient;
}
